import { TYPE_WH, WF_TRACKER } from "../../utils/Constant";

export const WMS_STATUS = {
  warehouse_approved: "warehouse_approved",
  NEW: 10,
  WAIT_APPROVE: 2
};

export enum EXPORT_CODE {
  KHACH_HANG = "X002",
  NCC = "X001",
  KHAC = "X006",
  HUY = "X007",
  HAO_PHI = "X008",
  HOAN_TRA = "X011",
  XUAT_HOA_DON = "X010",
  XUAT_Y_LENH_MAU = "X013",
  XUAT_NGOAI_VIEN = "X015",
}

export const EXPORT_FORM_CODE = {
  GENERAL: {
    NCC: 'themMoiPhieuXuatKhoNCC',
    KHACH_HANG: 'themMoiPhieuXuatKhoKH',
    KHAC: 'phieuXuatKhac',
    HUY: "formXuatHuy",
    HAO_PHI: "phieuXuatHaoPhi",
    HOAN_TRA: "xuatYLenhKhoNoiTru",
    NGOAI_VIEN: "phieuXuatKhoNgoaiVien",
  },
  VAT_TU: {
    NCC: 'formThemMoiVatTuXuatKhoNCC',
    KHACH_HANG: 'formThemMoiVatTuXuatKhoKH',
    KHAC: 'formThemMoiVatTuXuatKhoKhac',
    HUY: "formThemMoiVatTuXuatHuy",
    HAO_PHI: "themVatTuXuatHaoPhi",
    HOAN_TRA: "xuatYLenhKhoNoiTru",
    NGOAI_VIEN: "themVatTuPhieuXuatKhoNgoaiVien",
  },
  GENERAL_KHO_MAU: {
    NCC: 'xuatKhoNhaCungCapKhoMau',
    KHAC: 'xuatKhacKhoMau',
    HUY: "xuatHuyKhoMau",
    HAO_PHI: "phieuXuatHaoPhiKhoMau",
    HOAN_TRA: "xuatYLenhKhoNoiTru",
  },
  VAT_TU_KHO_MAU: {
    NCC: 'themVatTuPhieuXuatKhoNccKhoMau',
    KHACH_HANG: 'formThemMoiVatTuXuatKhoKH',
    KHAC: 'themVatTuPhieuXuatKhoKhacKhoMau',
    HUY: "themVatTuPhieuXuatHuyKhoMau",
    HAO_PHI: "themVatTuXuatHaoPhiKhoMau",
    HOAN_TRA: "xuatYLenhKhoNoiTru",
  },
}



export const EXPORT_OPTIONS: any[] = [
  // { code: "", name: "Xuất kho vật tư", modelId: "phieuXuatKhoAdd", modelIdVT: "formThemMoiVatTuXuatKho" },
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NCC,
  },
  {
    name: "Xuất khách hàng",
    code: EXPORT_CODE.KHACH_HANG,
    tracker: WF_TRACKER.THU_NGAN,
    type: TYPE_WH.THU_NGAN,
    modelId: EXPORT_FORM_CODE.GENERAL.KHACH_HANG,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHACH_HANG,
  },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  }
];
export const EXPORT_OPTIONS_KHAC: any[] = [
  // { code: "", name: "Xuất kho vật tư", modelId: "phieuXuatKhoAdd", modelIdVT: "formThemMoiVatTuXuatKho" },
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NCC,
  },
  // {
  //   name: "Xuất khách hàng",
  //   code: EXPORT_CODE.KHACH_HANG,
  //   tracker: WF_TRACKER.THU_NGAN,
  //   type: TYPE_WH.THU_NGAN,
  //   modelId: EXPORT_FORM_CODE.GENERAL.KHACH_HANG,
  //   modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHACH_HANG,
  // },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  },
];

export const EXPORT_OPTIONS_KHO_NOI_TRU: any[] = [
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NCC,
  },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  },
  // {
  //   name: "Xuất y lệnh (nội trú)",
  //   code: EXPORT_CODE.HOAN_TRA,
  //   tracker: WF_TRACKER.HOAN_TRA,
  //   type: TYPE_WH.EXPORT,
  //   modelId: EXPORT_FORM_CODE.GENERAL.HOAN_TRA,
  //   modelIdVT: EXPORT_FORM_CODE.VAT_TU.HOAN_TRA,
  // },
];
export const EXPORT_OPTIONS_KHO_BAO_HIEM: any[] = [
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NCC,
  },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  },
  {
    name: "Xuất hao phí khoa/phòng",
    code: EXPORT_CODE.HAO_PHI,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HAO_PHI,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HAO_PHI,
  },
  {
    name: "Xuất đơn thuốc",
    code: EXPORT_CODE.XUAT_HOA_DON,
    tracker: WF_TRACKER.XUAT_KHO_BAO_HIEM,
    type: TYPE_WH.EXPORT,
    modelId: "xuatkhobhyt",
    modelIdVT: "",
  },
];

export const EXPORT_OPTIONS_KHAC_KHO_MAU: any[] = [
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL_KHO_MAU.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU_KHO_MAU.NCC,
  },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL_KHO_MAU.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU_KHO_MAU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL_KHO_MAU.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU_KHO_MAU.HUY,
  },
  {
    name: "Xuất hao phí khoa/phòng",
    code: EXPORT_CODE.HAO_PHI,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL_KHO_MAU.HAO_PHI,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU_KHO_MAU.HAO_PHI,
  },
  {
    name: "Xuất y lệnh (kho máu)",
    code: EXPORT_CODE.XUAT_Y_LENH_MAU,
    tracker: WF_TRACKER.Y_LENH_MAU,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HOAN_TRA,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HOAN_TRA,
  },
  {
    name: "Xuất ngoại viện",
    code: EXPORT_CODE.XUAT_NGOAI_VIEN,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NGOAI_VIEN,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NGOAI_VIEN,
  },
];

export const EXPORT_OPTIONS_HAO_PHI = [
  {
    name: "Xuất hao phí khoa/phòng",
    code: EXPORT_CODE.HAO_PHI,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HAO_PHI,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HAO_PHI,
  },
];
export const EXPORT_OPTIONS_VVP: any[] = [
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  },
];
export const EXPORT_OPTIONS_TUONG_TAC_THUOC: any[] = [
  {
    name: "Xuất khách hàng",
    code: EXPORT_CODE.KHACH_HANG,
    tracker: WF_TRACKER.THU_NGAN,
    type: TYPE_WH.THU_NGAN,
    modelId: EXPORT_FORM_CODE.GENERAL.KHACH_HANG,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHACH_HANG,
  },
  {
    name: "Xuất y lệnh (nội trú)",
    code: EXPORT_CODE.HOAN_TRA,
    tracker: WF_TRACKER.HOAN_TRA,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HOAN_TRA,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HOAN_TRA,
  },
  {
    name: "Xuất hoá đơn",
    code: EXPORT_CODE.XUAT_HOA_DON,
    tracker: WF_TRACKER.XUAT_KHO_BAO_HIEM,
    type: TYPE_WH.EXPORT,
    modelId: "xuatkhobhyt",
    modelIdVT: "",
  },
]

export const EXPORT_OPTIONS_NOI_VIEN: any[] = [
  {
    name: "Xuất nhà cung cấp",
    code: EXPORT_CODE.NCC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NCC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NCC,
  },
  {
    name: "Xuất khác",
    code: EXPORT_CODE.KHAC,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.KHAC,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.KHAC,
  },
  {
    name: "Xuất huỷ",
    code: EXPORT_CODE.HUY,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HUY,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HUY,
  },
  {
    name: "Xuất hao phí khoa/phòng",
    code: EXPORT_CODE.HAO_PHI,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.HAO_PHI,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.HAO_PHI,
  },
  {
    name: "Xuất ngoại viện",
    code: EXPORT_CODE.XUAT_NGOAI_VIEN,
    tracker: WF_TRACKER.XUAT_KHO,
    type: TYPE_WH.EXPORT,
    modelId: EXPORT_FORM_CODE.GENERAL.NGOAI_VIEN,
    modelIdVT: EXPORT_FORM_CODE.VAT_TU.NGOAI_VIEN,
  },
];

export const OPTIONS_XUAT_DON_THUOC_BHYT: any = [
  {
    name: "Xuất đơn thuốc",
    code: EXPORT_CODE.XUAT_HOA_DON,
    tracker: WF_TRACKER.XUAT_KHO_BAO_HIEM,
    type: TYPE_WH.EXPORT,
    modelId: "xuatkhobhyt",
    modelIdVT: "",
  },
]